import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instantly jump to top when route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
